module.exports = __webpack_public_path__ + "static/img/ent-detail-23.c4f7b12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-23.jpg
// module id = rPkJ
// module chunks = 51